import { Location } from "@angular/common";
import { inject, Injectable, OnDestroy, DOCUMENT } from "@angular/core";
import { forkJoin, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";

import { Context, getBuildVersion, LOCALE, Settings } from "@hermes/core-app-core";
import { UserFacade } from "@hermes/hermes-web-states-user-state";
import {
    AnalyticsService,
    getAnalyticsDeviceType,
} from "@hermes/hermes-web-fragments-analytics";

import { NotFoundPageViewEvent } from "../../events/not-found-page-view.event";

@Injectable()
export class NotFoundPageAnalyticsService implements OnDestroy {
    private context = inject(Context);
    private userFacade = inject(UserFacade);
    private analyticsService = inject(AnalyticsService);
    private settings = inject(Settings);
    private location = inject(Location);
    private document = inject(DOCUMENT);
    private locale = inject(LOCALE);

    private subscription = new Subscription();

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Send analytics data for store page
     */
    public sendNotFoundPageViewEvent(): void {
        if (!this.context.isInBrowserMode()) {
            return;
        }

        this.subscription.add(
            forkJoin([
                this.userFacade.userPrefix$.pipe(take(1)),
                this.userFacade.userType$.pipe(
                    take(1),
                    map((userType) => userType || "non-connected"),
                ),
            ]).subscribe(([clientgender, clienttype]) => {
                this.analyticsService.sendData(
                    new NotFoundPageViewEvent({
                        eventname: "pageview",
                        pagename: this.document.title,
                        buildversion: getBuildVersion(this.settings.envKey),
                        devicetype: getAnalyticsDeviceType(),
                        languagecode: this.locale.langCode,
                        countrycode: this.locale.countryCode,
                        clienttype,
                        clientgender: clientgender as string,
                        pageTranslate: this.location.path().replace(/^\/+/, ""), // url after baseHref/locale, and without first slash.
                    }),
                );
            }),
        );
    }
}
